import React, { useEffect, useState, Fragment } from "react";
import Layout from "components/sales/layoutChange/layout";
import TableSection from "components/sales/tableSection/tableSection";
import Images from "assets/images/imageData";
import "components/sales/layoutChange/layout.css";

const CategoryList = ({ getCategoryList, categoryData = {} }) => {
  const headers = ["Category Name", "ERP ID", "Status", "Created At"];

  const [listData, setListData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [filterData, setFilterData] = useState(null);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await getCategoryList(null, 1);
      setIsLoading(false);
    })();
  }, [getCategoryList]);

  useEffect(() => {
  const tableData = ["name", "erp_id", "status", "created_at"];

  if (categoryData?.resultSets?.length > 0) {
    const data = categoryData.resultSets.map((element) =>
      Object.assign(
        {},
        ...tableData.map((key) => ({
          [key]:
            key === "status"
              ? element.status === 1
                ? "Active"
                : "Inactive"
              : element[key],
        })),
        {}
      )
    );

    setListData(data);
    setPageCount(Math.ceil(categoryData.total / categoryData.per_page));
  } else {
    setListData([]);
  }
}, [categoryData]);

  const onPageChange = async (val) => {
    setIsLoading(true);
    await getCategoryList(filterData, val.selected + 1);
    setIsLoading(false);
  };

  const headerBtns = () => {
    return (
      <Fragment>
        <a
          href={`/dashboard/procurement/add_category`}
          className="filter-hamburger btn btn-primary borderColorBox colorBox filterButton"
        >+ Add Category
        </a>
      </Fragment>
    );
  };

  return (
    <Layout
      title="Category List"
      Buttons={headerBtns}
      isLoading={isLoading}
    >
      <div className="row table-margin">
        <div className="col-md-12">
          <TableSection
            data={listData}
            isId={true}
            headers={headers}
            pageCount={pageCount}
            srNo={categoryData?.from}
            onPageChange={onPageChange}
          />
        </div>
      </div>
    </Layout>
  );
};

export default CategoryList;
